// Fechas de facturación en hora de Madrid (U-50, lote 3 del flujo de un día).
//
// `new Date().toISOString().split('T')[0]` da la fecha en UTC: a las 00:45
// del 1 de enero en Madrid propone el 31 de diciembre y la factura entra en
// la serie del año anterior. `hoyMadrid()` da la fecha de hoy en Madrid
// (AAAA-MM-DD) sin pasar por UTC, sea cual sea la zona del navegador.

const pad2 = (n) => String(n).padStart(2, '0');

export function hoyMadrid(ahora = new Date()) {
  try {
    const partes = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit',
    }).formatToParts(ahora);
    const v = (tipo) => (partes.find((p) => p.type === tipo) || {}).value;
    if (v('year') && v('month') && v('day')) return `${v('year')}-${v('month')}-${v('day')}`;
  } catch (e) {
    // Sin soporte de zonas horarias: la fecha local del navegador
  }
  return `${ahora.getFullYear()}-${pad2(ahora.getMonth() + 1)}-${pad2(ahora.getDate())}`;
}

// Texto del detalle de un error del API: el detalle puede ser un texto o un
// objeto ({mensaje, avisos}) como el 409 de regenerar o borrar una factura.
export function textoDetalleApi(detalle, porDefecto = 'Error') {
  if (!detalle) return porDefecto;
  if (typeof detalle === 'string') return detalle;
  if (detalle.mensaje) {
    const avisos = (detalle.avisos || []).map((a) => `- ${a.texto}`);
    return avisos.length ? `${detalle.mensaje}\n\n${avisos.join('\n')}` : detalle.mensaje;
  }
  try { return JSON.stringify(detalle); } catch (e) { return porDefecto; }
}

// Texto de la confirmación de regenerar o borrar una factura con sus avisos
// (GET /facturas/{id}/avisos-regenerar). E-08: no hay límites, el usuario
// confirma después de leerlos.
export function textoConfirmacionAvisos(textoBase, datos) {
  const avisos = (datos?.avisos || []).map((a) => `- ${a.texto}`);
  const info = (datos?.informativos || []).map((a) => `- ${a.texto}`);
  let texto = textoBase;
  if (avisos.length) texto += `\n\nAntes de seguir, ten en cuenta:\n${avisos.join('\n')}`;
  if (info.length) texto += `\n\nPara tu información:\n${info.join('\n')}`;
  if (avisos.length) texto += '\n\n¿Confirmas que quieres seguir?';
  return texto;
}
